import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {RevaApiEmailVerificationResult} from "../payload-types/authorize";

/**
 * #19351: POST {@link RevaApi.PATH_USER_EMAIL_VERIFICATION} — account-management sends the verification link to
 * the address stored for the logged-in user. reva-rest takes the user from the session, there is no payload.
 */
export class EmailVerificationApiInterface extends SimpleApiInterface<RevaApiEmailVerificationResult> {
    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_USER_EMAIL_VERIFICATION]);
    }

    protected executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<RevaApiEmailVerificationResult> {
        return executor.fetchPOST(url, credentials, {});
    }
}
